export const getIssueCommentApiUrl = (issueIdOrKey: string): string =>
	`/rest/api/3/issue/${issueIdOrKey}/comment`;

export const getIssueApiUrlForComment = (issueIdOrKey: string, commentId: string): string =>
	`${getIssueCommentApiUrl(issueIdOrKey)}/${commentId}`;
